// src/components/Blade.js
import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const Blade = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
  overflow: "hidden",
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.2)',
  },
}));

export default Blade;